const convertToastUISyntax = (markdown, unescapeTableContent = false) => {
    function convertBoldToStrong(text) {
        return text.replace(/\*\*(.+?)\*\*(?!\*)/g, '<strong>$1</strong>');
    }

    function processContent(inputContent) {
        const anchorTagPattern = /\[([^\]]+)\]\(([^)]+)\)/g;

        return inputContent.replace(anchorTagPattern, (match, text, url, offset) => {
            const before = inputContent.slice(0, offset);
            const after = inputContent.slice(offset + match.length);

            const preChar = before.trim().slice(-1);
            const postChar = after.trim().charAt(0);

            const hasPreText = preChar && !/\s/.test(preChar);
            const hasPostText = postChar && !/\s/.test(postChar);

            if (!hasPreText && !hasPostText) {
                return match;
            }
            if (hasPreText && !hasPostText) {
                return `${match}<br>`;
            }

            return match;
        });
    }

    function addBrAfterInLineElements(content) {
        const spanPattern = /(<span\b[^>]*>.*?<\/span>)(?=\n(?!\n))/g;
        const anchorTagPattern = /(\[([^\]]+)\]\(([^)]+)\))(?=\n(?!\n))/g;
        let updatedContent = content.replace(spanPattern, '$1<br>');
        updatedContent = updatedContent.replace(anchorTagPattern, '$1<br>');
        return updatedContent;
    }

    function unescapeAsterisksInTable(content) {
        return content.replace(/\\\*/g, '*');
    }

    if (!markdown) {
        return markdown;
    }
    const processedMarkdown = addBrAfterInLineElements(markdown);
    const lines = processedMarkdown.split('\n');
    let htmlTable = '';
    let inTable = false;
    let inHeader = false;
    let rowCount = 0;

    lines.forEach((line) => {
        const isSeparatorRow = line.match(/^\|\s*:?-+:?\s*\|/);
        if (line.startsWith('|') && !isSeparatorRow) {
            if (!inTable) {
                inTable = true;
                htmlTable += `<table>\n`;
                inHeader = true;
                htmlTable += `<thead>\n`;
            }
            const cells = line
                .split('|')
                .slice(1, -1)
                .map((cell) => cell.trim());
            htmlTable += `<tr>\n`;
            cells.forEach((cell) => {
                const tag = inHeader && rowCount === 0 ? 'th' : 'td';
                let content = cell;
                let attributes = '';

                if (cell.includes('@cols=')) {
                    const colspan = cell.match(/@cols=(\d+):/)[1];
                    content = content.replace(/@cols=(\d+):/, '').trim();
                    attributes += ` colspan="${colspan}"`;
                }
                if (cell.includes('@rows=')) {
                    const rowspan = cell.match(/@rows=(\d+):/)[1];
                    content = content.replace(/@rows=(\d+):/, '').trim();
                    attributes += ` rowspan="${rowspan}"`;
                }
                if (cell.match(/^-+$/)) {
                    content = '';
                }
                if (cell.match(/<\/tr>\s*rows=(\d+):/)) {
                    const rowspan = cell.match(/@rows=(\d+):/)[1];
                    content = cell.replace(/<\/tr>\s*rows=(\d+):/, '').trim();
                    attributes = ` rowspan="${rowspan}"`;
                }
                content = processContent(content);
                content = convertBoldToStrong(content);
                if (unescapeTableContent) {
                    content = unescapeAsterisksInTable(content);
                }
                htmlTable += `  <${tag}${attributes}>${content}</${tag}>\n`;
            });
            htmlTable += ` </tr>\n`;
            rowCount += 1;
            if (inHeader && rowCount === 1) {
                inHeader = false;
                htmlTable += '</thead>\n <tbody>\n';
            }
        } else if (inTable && isSeparatorRow) {
            // skip separator
        } else {
            if (inTable) {
                inTable = false;
                if (rowCount > 1) {
                    htmlTable += ' </tbody>\n';
                }
                htmlTable += '</table>\n';
                rowCount = 0;
            }
            htmlTable += `${convertBoldToStrong(processContent(line))}\n`;
        }
    });

    if (inTable) {
        if (inHeader) {
            htmlTable += '</thead>\n';
        }
        if (rowCount > 0) {
            htmlTable += '</tbody>\n';
        }
        htmlTable += '</table>\n';
    }

    return htmlTable.trim();
};

export default convertToastUISyntax;
